export function processErrorObject(error: any) {
    if (!error?.response?.errors?.[0]?.description) {
        return error;
    }

    return {
        ...error,
        response: {
            ...error.response,
            errors: error.response.errors.map((err: any) => ({
                ...err,
                description: extractCleanMessage(err.description),
            })),
        },
    };
}

function extractCleanMessage(message: string): string {
    if (!message) return message;
    const detailsMatch = message.match(/details = "([^"]+)"/);
    if (detailsMatch && detailsMatch[1]) {
        const valueErrorMatch = detailsMatch[1].match(/Unexpected <class 'ValueError'>: (.*?)(?="|\n|$)/);
        return valueErrorMatch ? valueErrorMatch[1].trim() : detailsMatch[1].trim();
    }
    return message;
}
